import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  RunType,
  RunTypeResponse,
  RunTypeSingleResponse
} from 'Interfaces/ReferenceInterfaces/RunTypeInterface';

export const runTypeScreenServices = {
  getAllRunTypes: (page = 1, pageSize = 10000): Promise<RunTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RunTypeResponse>(
          `pps/run-types?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRunTypeById: (id: number): Promise<RunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RunTypeSingleResponse>(`pps/run-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createRunType: (runTypeData: Partial<RunType>): Promise<RunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<RunTypeSingleResponse>('pps/run-types/', runTypeData);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateRunType: (id: number, runTypeData: Partial<RunType>): Promise<RunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<RunTypeSingleResponse>(
          `pps/run-types/${id}/`,
          runTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteRunType: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/run-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
